import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import clsx from 'clsx';
import React from 'react';
import FeesBody from '@/components/molecules/FeesBody';
import InfoTooltip from '@/components/molecules/InfoTooltip';
import TableBody from '@/components/molecules/TableBody';
import { CryptoTableType } from '@/utils/types';
import DesktopTableSkeleton from './partials/DesktopTableSkeleton';
const DesktopTable = t0 => {
  const $ = _c(21);
  const {
    headers,
    rows,
    variant,
    feesRow,
    tooltip,
    howToButtonLabel,
    isLoading
  } = t0;
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <DesktopTableSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== feesRow || $[2] !== tooltip) {
    t1 = feesRow && <th className="bg-primary-200 text-h8 w-1/3 py-3.5 text-left font-bold first:rounded-l-lg last:rounded-r-lg" scope="col"><div className="hidden items-center gap-x-2 lg:flex">{feesRow}{tooltip}</div></th>;
    $[1] = feesRow;
    $[2] = tooltip;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== headers || $[5] !== variant) {
    let t3;
    if ($[7] !== headers.length || $[8] !== variant) {
      t3 = (header, index) => <th className={clsx("bg-primary-200 text-h8 py-3.5 font-bold first:rounded-l-lg last:rounded-r-lg", {
        "w-1/4": index === 0 && (variant == "buyTable" || variant == "sellTable")
      })} key={header.text} scope="col"><div className={clsx("flex flex-row items-center gap-x-2", {
          "justify-end": index === headers.length - 1
        })}>{header.text}{!!header.tooltip && <InfoTooltip description={header.tooltip} />}</div></th>;
      $[7] = headers.length;
      $[8] = variant;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = headers.map(t3);
    $[4] = headers;
    $[5] = variant;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[10] !== t1 || $[11] !== t2) {
    t3 = <thead className="text-primary-600"><tr className="child:first:pl-6 child:last:pr-6 child:last:text-end">{t1}{t2}</tr></thead>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== feesRow || $[14] !== howToButtonLabel || $[15] !== rows || $[16] !== variant) {
    t4 = variant == "buyTable" || variant == "sellTable" ? <TableBody rows={rows} variant={variant} howToButtonLabel={howToButtonLabel} /> : <FeesBody feesRow={feesRow} rows={rows} variant={variant} howToButtonLabel={howToButtonLabel} />;
    $[13] = feesRow;
    $[14] = howToButtonLabel;
    $[15] = rows;
    $[16] = variant;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== t3 || $[19] !== t4) {
    t5 = <table className="crypto-table mt-8 hidden w-full table-fixed border-separate border-spacing-0 lg:table" data-sentry-component="DesktopTable" data-sentry-source-file="index.tsx">{t3}{t4}</table>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
};
export default DesktopTable;